import { Table } from "../../../../../../components/Functional";
import { Button, Modal } from "../../../../../../components/ui";
import { FETCH_CONDITIONS_V2 as fetchConditionsV2 } from "../../../../../../graphql/query/Condition";
import useUser from "../../../../../../hooks/useUser";
import SectionHeader from "../../components/SectionHeader";
import Actions from "./components/Actions";
import AddCondition from "./components/AddConditionBody";
import ConditionStatus from "./components/ConditionStatus";

const InstanceCondition = (props = {}) => {
  const { instanceId, instance } = props;
  const { hasPermission, user } = useUser();

  const modalProps = {
    body: AddCondition,
    closeOnBackdrop: true,
    instance,
    user,
    hideCloseButton: true,
    scale: "md",
  };

  const actions = [
    {
      component: () => {
        return (
          <div className="flex items-center gap-4">
            {hasPermission("CREATE_CONDITION") && (
              <Modal {...modalProps}>
                <Button label="Log Condition" />
              </Modal>
            )}
            <Button
              label="Articheck"
              disabled={!instance?.articheckUrl}
              onClick={() => window.open(instance.articheckUrl, "_blank")}
            />
          </div>
        );
      },
    },
  ];

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "conditionsV2",
    headers: [
      { label: "Date", name: "date", type: "date" },
      { label: "Updated", name: "time", type: "date" },
      { label: "User", name: "user", type: "label" },
      {
        label: "Status",
        name: "status.description",
        type: "custom",
        component: ConditionStatus,
      },
      { label: "Frame Status", name: "mountStatus.description", type: "label" },
      {
        label: "Description",
        name: "description",
        type: "custom",
        component: props => {
          const { description, id } = props.row;

          return (
            <div
              key={id}
              data-tooltip-id="global-text-tooltip"
              data-tooltip-content={description}
              className="w-[200px] cursor-pointer overflow-hidden truncate text-ellipsis whitespace-nowrap p-2"
            >
              {description}
            </div>
          );
        },
      },
      {
        label: "",
        name: "actions",
        type: "custom",
        instance,
        component: hasPermission("CREATE_CONDITION") ? Actions : null,
      },
    ],
    inputs: [],
    FETCH_QUERY: fetchConditionsV2({
      mountStatus: true,
      status: true,
      date: true,
      time: true,
      user: true,
      description: true,
      articheckId: true,
      articheckRevision: true,
    }),
    variables: {
      _instance: {
        id: {
          operator: "eq",
          value: instanceId,
        },
      },
    },
    className: "sm:px-0 lg:px-0",
  };

  return (
    <div className="w-full">
      <SectionHeader title="Condition" actions={actions} />
      <div className="flex w-full">
        <div className="flex-1">
          <Table {...tableProps} />
        </div>
      </div>
    </div>
  );
};

export default InstanceCondition;
